// Generic formatters for charts/cards/tooltips
const currencyFormatter =
  (currency = 'USD', minimumFractionDigits = 0) =>
  (value) =>
    new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
      minimumFractionDigits,
      maximumFractionDigits: Math.max(2, minimumFractionDigits),
    }).format(Number(value) || 0);

const numberFormatter =
  (minimumFractionDigits = 0, maximumFractionDigits = 1) =>
  (value) =>
    new Intl.NumberFormat('en-US', {
      minimumFractionDigits,
      maximumFractionDigits,
    }).format(Number(value) || 0);

const percentFormatter =
  (minimumFractionDigits = 0, maximumFractionDigits = 1) =>
  (value) =>
    `${numberFormatter(minimumFractionDigits, maximumFractionDigits)(Number(value) * 100)}%`;

const dateFormatter = (value) => {
  try {
    return new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric' }).format(
      new Date(value)
    );
  } catch {
    return value;
  }
};

export { currencyFormatter, numberFormatter, percentFormatter, dateFormatter };
